import StyledPage from "./StyledPage";
import PriceBg from "../assets/price-bg.png";
import Price from "../assets/price.png";
import Price2 from "../assets/price-2.png";
import Price3 from "../assets/price-3.png";
import React from "react";
import "../style/price-page.css";
import TimeTable from "../assets/timetable.png";
import Notice from "../assets/notice.png";


const PricePage = () => {
  return (
    <StyledPage>
      <div className={'price-page'}>
        <div className={'price-first-frame'}>
          <img className={'price-first-bg'} src={PriceBg} alt={''}/>
          <div className={'price-first-content'}>
            <img className={'price-first-content-1'} src={Price} alt={''}/>
            <img className={'price-first-content-2'} src={Price2} alt={''}/>
            <img className={'price-first-content-3'} src={Price3} alt={''}/>
          </div>
        </div>
        <div className={'price-second-frame'}>
          <img className={'price-second-content'} src={TimeTable} alt={''}/>
          <img className={'price-second-content'} src={Notice} alt={''}/>
        </div>
      </div>
    </StyledPage>
  )
}

export default PricePage;